import { NovedadesService } from './../../../services/rrhh/novedades/novedades.service';
import { Idle } from 'idlejs/dist';
import { ParamEntity } from './../../../models/general/param.model';
import { UserValuesService } from './../../../services/utils/user-values.service';
import { Nomina } from './../../../models/rrhh/nomina.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Marcacion } from 'src/app/models/rrhh/marcacion.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-nomina',
  templateUrl: './modal-nomina.component.html',
  styleUrls: ['./modal-nomina.component.css']
})
export class ModalNominaComponent implements OnInit {
  displayedColumns: string[] = [
    'Seccion',
    'IdLegajo',
    'Apellido',
    'Nombre',
    'Cuil',
    'Fingreso',
    'Fegreso',
    'antiguedad',
    'Accion'
  ];
  dataSource = new MatTableDataSource<Nomina>([]);
  @ViewChild(MatPaginator, { static: true }) set matPaginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }
  nominaList: Nomina[] = [];
  listNominaCofarsur: any[] = [];

  constructor(
    private userValuesService: UserValuesService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ModalNominaComponent>,
    private novedadesService: NovedadesService
  ) {
    // this.listNominaCofarsur = data;
  }

  ngOnInit() {
    this.dataSource.filterPredicate = (data: Nomina, filter: string) => {
      return (
        (data.Seccion && data.Seccion.includes(filter)) ||
        (data.IdLegajo && data.IdLegajo.toString().includes(filter)) ||
        (data.Apellido && data.Apellido.toLowerCase().includes(filter)) ||
        (data.Nombre && data.Nombre.toLowerCase().includes(filter)) ||
        (data.Cuil && data.Cuil.toString().includes(filter))
      );
    }
    this.getNominaGrilla();
  }

  cerrarModal() {
    this.dialogRef.close();
  }

  filtrarGrilla(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getNominaGrilla() {
    const paramEntity = new ParamEntity();
    paramEntity.IdLegajo = 0;
    paramEntity.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.Tipo = 'TOTAL';

    this.novedadesService.getNominaGrilla(paramEntity).subscribe((result: Nomina[]) => {
      result.forEach(nomina => {
        nomina.FechaIngreso = nomina.FechaIngreso.toString() === '0001-01-01T00:00:00' ? null : nomina.FechaIngreso;
        nomina.FechaEgreso = nomina.FechaEgreso.toString() === '0001-01-01T00:00:00' ? null : nomina.FechaEgreso;
      });
      this.nominaList = result;
      this.dataSource.data = this.nominaList;
      this.getCheckboxSelected(true);
    });
  }

  getRowData(marcacion: Nomina) {
    this.dataSource.data.forEach(element => {
      if (element && element !== marcacion) {
        element.Seleccionado = false;
      }
    });
    marcacion.Seleccionado = !marcacion.Seleccionado;
  }

  agregarPersona(marcacion: Nomina) {
    this.dialogRef.close(marcacion);
  }

  getCheckboxSelected(checked) {
    this.dataSource.data = this.nominaList.filter(x => checked ? !x.FechaEgreso : x.FechaIngreso);
  }

}
